import { useSupportSheet } from "../components/SupportSheet";
import { memo } from 'react';
import { useStore } from '../store/globalState';
import { useSessionStore } from '../store/useSessionStore';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BodyCopy } from '../components/BodyCopy';
import {
  AuraLayout,
  Button,
  CashSpecialIcon,
  Layout,
  PageTitle,
  SupportIcon,
} from 'lola-framework-ui-test';
import { FlowHeroMark } from '../components/FlowHeroMark';
import { APP_ROUTES, CASH_DEPOSIT_ROUTES, TITLE_COLOR } from '../constants';
import { ScrollFadeIndicator } from "../components/ScrollFadeIndicator";
import { Navbar } from '../components/Navbar';

/**
 * Gallery-safe cash-deposit landing screen.
 *
 * Greets the user and invites them to make a cash deposit at thousands of
 * physical locations. Continue opens the cash-stores barcode screen (wildcard
 * policy default in live). The how-to carousel is reached from there.
 */
export const CashDepositLandingPage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const { session } = useSessionStore();
  const colorConfig = theme.whiteView;
  const { backgroundBtn, textColorBtn, bodyCopy, dropzoneColors, backgroundIcon } =
    colorConfig;
  const navigate = useNavigate();
  const { openSupport, supportSheet } = useSupportSheet("cash-deposit");

  const firstName =
    session.data?.userData?.name?.firstName ??
    session.data?.userData?.fullName?.split(' ')[0] ??
    '';

  return (
    <>
    <AuraLayout colorConfig={colorConfig} className="need-help-header flow-landing-page">
      <Layout.Header>
        <Navbar
          title={t('transactions.needHelp')}
          align="right"
          color={bodyCopy}
          onBackClick={() => navigate(CASH_DEPOSIT_ROUTES.WELCOME)}
          onIconClick={openSupport}
          icon={<SupportIcon size={35} colors={dropzoneColors} />}
        />
      </Layout.Header>
      <Layout.Content className="landing-section flow-hero-section flow-hero-section--with-header">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <CashSpecialIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container landing-container--tight">
            <PageTitle
              highlight={
                firstName
                  ? `${t('cashDeposit.greeting')} ${firstName}`
                  : t('cashDeposit.greeting')
              }
              highlightColor={TITLE_COLOR}
            />
            <BodyCopy textColor={bodyCopy} className="cash-deposit-landing-body">
              {t('cashDeposit.body')}
            </BodyCopy>
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => navigate(APP_ROUTES.CASH_STORES_PAGE)}
          >
            {t('cashDeposit.cta')}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
    {supportSheet}
  </>
  );
});
